<template>
  <div class="register-page-wrapper">
    <!-- 装饰背景光晕 -->
    <div class="bg-glow-layer" aria-hidden="true">
      <div class="bg-blob bg-blob-blue"></div>
      <div class="bg-blob bg-blob-orange"></div>
      <div class="bg-grid-overlay"></div>
    </div>

    <!-- 主内容 -->
    <div class="main-content" style="justify-content:center; padding:48px 24px;">
      <div class="auth-split-shell">
        <AuthBrandPanel />
        <!-- 右侧注册卡片 -->
        <div class="register-form-container">
          <el-card class="register-card" shadow="always">
            <!-- 关闭按钮 -->
<!--            <el-icon class="close-btn" @click="goBack">-->
<!--              <Close />-->
<!--            </el-icon>-->

            <div class="register-body">
              <div class="register-form-wrapper">
                <!-- 顶部注册提示 -->
                <div class="register-header">
                  <div class="header-eyebrow">欢迎加入</div>
                  <h3>微信扫码注册</h3>
                  <p class="header-sub">使用微信扫描下方二维码即可完成注册</p>
                </div>

                <!-- 微信注册容器 -->
                <div class="wechat-register-container">
                  <!-- 正常二维码显示 -->
                  <div v-if="wechatQrCodeUrl && !isQrCodeExpired" class="wechat-qrcode">
                    <img :src="wechatQrCodeUrl" alt="微信注册二维码" />
                  </div>

                  <!-- 二维码过期提示 -->
                  <div v-else-if="isQrCodeExpired && wechatQrCodeUrl" class="wechat-qrcode expired-wrapper">
                    <img :src="wechatQrCodeUrl" alt="已过期的微信注册二维码" class="expired-img" />
                    <div class="expired-mask" @click="refreshQrCode">
                      <div class="expired-content">
                        <el-icon class="expired-icon"><WarningFilled /></el-icon>
                        <p class="expired-text">二维码已过期</p>
                      </div>
                    </div>
                  </div>

                  <!-- 加载占位 -->
                  <div v-else class="loading-qrcode">
                    <div class="loading-spinner"></div>
                  </div>

                </div>

                <!-- 登录链接 -->
                <div class="login-link">
                  <span>已有账号？</span>
                  <el-link type="primary" @click="navigateToLogin" style="font-style: italic">去登录</el-link>
                </div>

                <!-- 用户协议和隐私政策 -->
                <div class="agreement">
                  注册即表示同意
                  <el-link type="primary" @click="showTermsDialog">《用户协议》</el-link>
                  和
                  <el-link type="primary" @click="showPrivacyDialog">《隐私政策》</el-link>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 底部版权信息（与登录页统一） -->
    <el-footer class="register-footer" height="auto">
      <div class="footer-glow footer-glow-blue" aria-hidden="true"></div>
      <div class="footer-glow footer-glow-orange" aria-hidden="true"></div>
      <div class="footer-content">
        <div class="footer-main">
          <div class="footer-sections">
            <!-- 网站介绍 -->
            <div class="footer-section">
              <h4 class="section-title footer-logo-text">易印工具</h4>
              <p class="footer-desc">
                专业的印前设计工具，让设计更加高效精准。我们致力于为各行业提供最优质的印前解决方案。
              </p>
            </div>

            <!-- 联系方式 -->
            <div class="footer-section">
              <h4 class="section-title">联系方式</h4>
              <div class="contact-info">
                <div class="contact-item">
                  <el-icon><Message /></el-icon>
                  <span>3052594895@qq.com</span>
                </div>
                <div class="contact-item">
                  <el-icon><Phone /></el-icon>
                  <span>18925330037</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 底部版权信息 -->
          <div class="footer-bottom">
            <div class="copyright-section">
              <div class="copyright-text">
                © 2026 中山市易印网络科技有限公司.保留所有权利.
              </div>
            </div>
            <div class="certification-info">
              <div class="beian-container">
                <img
                    src="/eprinttools-files/front-end/police.png"
                    alt="公安备案图标"
                    class="beian-icon"
                />
                <a href="http://www.beian.gov.cn" target="_blank" class="beian-link">
                  粤公网安备 44200002443702号
                </a>
                <span class="divider">|</span>
                <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                  粤ICP备16014837号
                </a>
              </div>
              <div class="legal-links">
                <a href="/privacyPolicy" @click.prevent="showPrivacyDialog" class="legal-link">隐私政策</a>
                <span class="divider">|</span>
                <a href="/userAgreement" @click.prevent="showTermsDialog" class="legal-link">用户协议</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-footer>
  </div>

  <!-- 服务条款弹窗 -->
  <el-dialog
      v-model="termsDialogVisible"
      :title="null"
      width="60%"
      top="8vh"
      class="policy-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <template #header>
      <div class="dialog-header">
        <div class="dialog-header-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
            <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M14 2v6h6M9 13h6M9 17h6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <h3>用户协议</h3>
          <p>请仔细阅读以下条款</p>
        </div>
      </div>
    </template>
    <div class="dialog-content" v-html="termsContent"></div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="termsDialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 隐私政策弹窗 -->
  <el-dialog
      v-model="privacyDialogVisible"
      :title="null"
      width="60%"
      top="8vh"
      class="policy-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <template #header>
      <div class="dialog-header">
        <div class="dialog-header-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <h3>隐私政策</h3>
          <p>我们如何保护您的个人信息</p>
        </div>
      </div>
    </template>
    <div class="dialog-content" v-html="privacyContent"></div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="privacyDialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 绑定手机弹窗 -->
  <BindPhoneDialog
      v-model="bindPhoneDialogVisible"
      :session-id="currentSessionId"
      @bind-success="handleBindSuccess"
  />

</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Close } from '@element-plus/icons-vue'
import request from '@/utils/request'
import { useAuthState } from '@/stores/authState'
import BindPhoneDialog from '@/components/BindPhoneDialog.vue'
import AuthBrandPanel from '@/components/auth/AuthBrandPanel.vue'
import { TERMS_CONTENT, PRIVACY_CONTENT } from '@/constants/authContent'

const { setToken } = useAuthState()

const router = useRouter()

// 微信注册相关
const wechatQrCodeUrl = ref('')
const currentSessionId = ref('')
const bindPhoneDialogVisible = ref(false)
let pollingTimer = null

// 二维码过期控制
const isQrCodeExpired = ref(false)

// 弹窗控制变量
const termsDialogVisible = ref(false)
const privacyDialogVisible = ref(false)

// 用户协议内容
const termsContent = ref(TERMS_CONTENT)

// 隐私政策内容
const privacyContent = ref(PRIVACY_CONTENT)

// 显示对话框的方法
const showTermsDialog = () => {
  termsDialogVisible.value = true
}

const showPrivacyDialog = () => {
  privacyDialogVisible.value = true
}

// 返回上一页
const goBack = () => {
  clearPolling()
  router.go(-1)
}

// 跳转到登录页
const navigateToLogin = () => {
  clearPolling()
  router.push('/login')
}

// 清理轮询函数
const clearPolling = () => {
  if (pollingTimer) {
    clearTimeout(pollingTimer)
    pollingTimer = null
  }
}

// 刷新二维码
const refreshQrCode = () => {
  isQrCodeExpired.value = false
  generateWechatQrCode()
}

// 生成微信注册二维码
const generateWechatQrCode = async () => {

  // 重置过期状态
  isQrCodeExpired.value = false
  // 清理旧轮询
  clearPolling()

  try {
    const response = await request.get('/auth/wechat/mp-qrcode')
    const { qrUrl, sessionId } = response.data

    wechatQrCodeUrl.value = qrUrl
    currentSessionId.value = sessionId

    // 启动轮询检查注册状态
    startPolling()
  } catch (error) {
    // ElMessage.error('获取二维码失败')
  }
}

// 启动轮询
const startPolling = () => {
  clearPolling()

  const poll = async () => {
    try {
      const statusRes = await request.get('/auth/wechat/login/status', {
        params: { sessionId: currentSessionId.value }
      })

      const responseData = statusRes.data || {}

      if (responseData.status === 'success') {
        const token = responseData.token
        const hasBoundPhone = responseData.hasBoundPhone

setToken( token)
        console.log('注册Token存储完成:', localStorage.getItem('auth_token'))


        await new Promise((resolve) => setTimeout(resolve, 500))

        if (hasBoundPhone) {
          ElMessage.success('微信注册成功')
          clearPolling()
          router.push('/home')
        } else {
          bindPhoneDialogVisible.value = true
        }
      } else if (responseData.status === 'waiting_bind') {
        bindPhoneDialogVisible.value = true
      } else if (responseData.status === 'expired') {
        // 二维码过期，显示过期遮罩，停止轮询
        isQrCodeExpired.value = true
        clearPolling()
      } else if (responseData.status === 'waiting') {
        pollingTimer = setTimeout(poll, 2000)
      }
    } catch (error) {
      console.error('轮询错误:', error)
      pollingTimer = setTimeout(poll, 2000)
    }
  }

  pollingTimer = setTimeout(poll, 2000)
}

// 处理绑定成功
const handleBindSuccess = () => {
  clearPolling()


  setTimeout(() => {
    ElMessage.success('注册成功！')
    router.push('/home')
  }, 500)
}

onMounted(() => {
  generateWechatQrCode()
})

onUnmounted(() => {
  clearPolling()
})
</script>

<style scoped lang="scss">
/* =========================================================
   2026 现代化设计系统 - 注册页样式 (与登录页完全统一)
   主色: #2f5bff / #f59e0b  |  背景基色: #f7f9fc
   ========================================================= */

/* ---------- 根容器 ---------- */
.register-page-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background:
      radial-gradient(ellipse 900px 700px at 12% 5%, rgba(47, 91, 255, 0.12), transparent 60%),
      radial-gradient(ellipse 800px 600px at 88% 8%, rgba(245, 158, 11, 0.08), transparent 55%),
      radial-gradient(ellipse 700px 500px at 50% 100%, rgba(47, 91, 255, 0.05), transparent 55%),
      #f7f9fc;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  overflow-x: hidden;
}

/* ---------- 装饰背景光晕层 ---------- */
.bg-glow-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;

  .bg-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.5;
    animation: floatBlob 18s ease-in-out infinite;
  }

  .bg-blob-blue {
    width: 520px;
    height: 520px;
    top: -120px;
    left: -100px;
    background: radial-gradient(circle, rgba(47, 91, 255, 0.45), transparent 70%);
  }

  .bg-blob-orange {
    width: 460px;
    height: 460px;
    top: 10%;
    right: -120px;
    background: radial-gradient(circle, rgba(245, 158, 11, 0.4), transparent 70%);
    animation-delay: -6s;
  }

  .bg-grid-overlay {
    position: absolute;
    inset: 0;
    background-image:
        linear-gradient(rgba(47, 91, 255, 0.04) 1px, transparent 1px),
        linear-gradient(90deg, rgba(47, 91, 255, 0.04) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 75%);
    -webkit-mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 75%);
  }
}

/* ---------- 主内容区 (与登录页完全一致) ---------- */
.main-content {
  background: transparent;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  box-sizing: border-box;
  padding: 0 10% 0 0;
}

.auth-split-shell {
  display: block;
  width: 100%;
  max-width: 360px;
  margin-right: 0;
}

/* ---------- 右侧注册卡片 ---------- */
.register-form-container {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;

  .register-card {
    width: 100%;
    max-width: 100%;
    overflow: visible;
    border: 1px solid rgba(226, 232, 240, 0.9);
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(20px);
    box-shadow:
        0 20px 50px rgba(15, 23, 42, 0.1),
        0 6px 20px rgba(47, 91, 255, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.6);
    position: relative;
    padding: 0;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);

    &:hover {
      box-shadow:
          0 24px 60px rgba(15, 23, 42, 0.14),
          0 8px 28px rgba(47, 91, 255, 0.12);
    }

    :deep(.el-card__body) {
      padding: 0 !important;
      border-radius: 20px;
      overflow: hidden;
    }
  }
}

/* 关闭按钮 - 现代圆形玻璃按钮 (与登录页一致) */
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  color: #64748b;
  z-index: 10;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    color: #dc2626;
    background: rgba(220, 38, 38, 0.08);
    border-color: rgba(220, 38, 38, 0.2);
    transform: rotate(90deg) scale(1.05);
    box-shadow: 0 6px 16px rgba(220, 38, 38, 0.18);
  }
}

/* 表单主体 */
.register-body {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
}

.register-form-wrapper {
  flex: 1;
  padding: 28px 26px 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: auto;
}

/* ---------- 注册头部 (与登录页一致) ---------- */
.register-header {
  margin-bottom: 20px;
  text-align: left;

  .header-eyebrow {
    display: inline-block;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #f59e0b;
    background: rgba(245, 158, 11, 0.08);
    padding: 4px 12px;
    border-radius: 999px;
    border: 1px solid rgba(245, 158, 11, 0.15);
    margin-bottom: 10px;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: 800;
    margin: 0 0 6px;
    background: linear-gradient(135deg, #0f172a 0%, #142c84 55%, #1f43cc 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: -0.5px;
    line-height: 1.2;
  }

  .header-sub {
    margin: 0;
    font-size: 0.88rem;
    color: #64748b;
    font-weight: 400;
  }
}

/* ---------- 微信注册容器 ---------- */
.wechat-register-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 0 6px;
  position: relative;

  .wechat-qrcode {
    position: relative;
    text-align: center;
    margin-bottom: 14px;
    padding: 16px;
    border-radius: 22px;
    background: #ffffff;
    box-shadow:
        0 16px 40px rgba(15, 23, 42, 0.08),
        0 0 0 1px rgba(226, 232, 240, 0.8);

    img {
      width: 200px;
      height: 200px;
      display: block;
      margin: 0 auto;
      border-radius: 12px;
      position: relative;
      z-index: 2;
    }
  }

  /* 过期样式 */
  .expired-wrapper {
    position: relative;
    .expired-img {
      opacity: 0.4;
      filter: grayscale(100%);
    }

    .expired-mask {
      position: absolute;
      top: 16px;
      left: 16px;
      right: 16px;
      bottom: 16px;
      background: rgba(248, 250, 252, 0.75);
      backdrop-filter: blur(4px);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(248, 250, 252, 0.92);
      }

      .expired-content {
        text-align: center;
        padding: 16px;

        .expired-icon {
          font-size: 36px !important;
          color: #f59e0b !important;
          margin-bottom: 8px;
          filter: drop-shadow(0 4px 12px rgba(245, 158, 11, 0.3));
        }

        .expired-text {
          font-size: 14px !important;
          color: #d40c0c !important;
          margin: 0 0 12px;
          font-weight: 500;
        }

        .refresh-btn {
          padding: 6px 16px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 13px;
          height: auto;
          background: linear-gradient(135deg, #2f5bff 0%, #5b7cff 100%) !important;
          border: none;
          box-shadow: 0 4px 12px rgba(47, 91, 255, 0.3);
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 6px 16px rgba(47, 91, 255, 0.4);
          }
        }
      }
    }
  }

  .loading-qrcode {
    padding: 60px 0 50px;
    color: #64748b;
    font-size: 14px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;

    .loading-spinner {
      width: 36px;
      height: 36px;
      border: 3px solid rgba(47, 91, 255, 0.15);
      border-top-color: #2f5bff;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
  }

}

/* ---------- 登录链接 ---------- */
.login-link {
  text-align: center;
  font-size: 13.5px;
  padding: 12px 0;
  margin-top: 4px;
  border-bottom: 1px dashed rgba(226, 232, 240, 0.9);

  span {
    color: #64748b;
    vertical-align: middle;
  }

  .el-link {
    font-size: 13.5px;
    vertical-align: middle;
    font-weight: 600;
  }
}

/* ---------- 协议 ---------- */
.agreement {
  text-align: center;
  font-size: 12.5px;
  color: #64748b;
  margin-top: 12px;
  line-height: 1.7;
  padding: 4px 6px;

  .el-link {
    font-size: 12.5px;
    vertical-align: baseline;
    font-weight: 500;
    transition: all 0.25s ease;

    &:hover {
      color: #1f43cc;
    }
  }

  span {
    color: #94a3b8;
    font-size: 12.5px;
  }
}

/* ---------- 底部 footer  ---------- */
.register-footer {
  position: relative;
  color: #475569;
  flex-shrink: 0;
  padding: 16px 24px 12px;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
  overflow: hidden;
  background: linear-gradient(135deg, #e8edf2 0%, #f2f0f2 45%, #f8f4f0 100%);

  .footer-glow {
    display: none;
  }

  .footer-content {
    position: relative;
    z-index: 1;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 62px 62px;
  }

  .footer-sections {
    background: transparent;
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    gap: 42px;
    margin-bottom: 10px;
  }

  .footer-section:first-child {
    padding-right: 10px;
  }

  .footer-logo-text {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
    background: linear-gradient(135deg, #2f5bff, #f59e0b);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .footer-desc {
    background: transparent;
    color: #64748b;
    line-height: 1.7;
    font-size: 0.88rem;
    margin: 0;
  }

  .section-title {
    color: #1e293b;
    font-size: 1rem;
    font-weight: 700;
    margin: 0 0 8px;
    position: relative;
    display: inline-block;
  }

  .contact-info {
    background: transparent;
    display: flex;
    line-height: 1.7;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px 24px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    white-space: nowrap;

    &:hover {
      color: #1e293b;
    }
  }

  .contact-item .el-icon {
    color: #f59e0b;
    font-size: 1rem;
  }

  .footer-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 16px;
    padding-top: 8px;
    border-top: 1px solid rgba(141, 143, 146, 0.6);
  }

  .copyright-section {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .copyright-text {
    font-size: 0.8rem;
    color: #94a3b8;
  }

  .legal-links {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .legal-link {
    color: #94a3b8;
    text-decoration: none;
    font-size: 0.82rem;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      color: #1f43cc;
    }
  }

  .divider {
    color: #cbd5e1;
    font-size: 0.78rem;
  }

  .certification-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .beian-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .beian-icon {
    height: 16px;
    width: auto;
    filter: brightness(0.9);
  }

  .beian-link,
  .icp-link {
    color: #94a3b8;
    text-decoration: none;
    font-size: 0.78rem;
    transition: color 0.3s ease;

    &:hover {
      color: #1f43cc;
    }
  }
}

/* ---------- 政策弹窗 ---------- */
.policy-dialog {
  :deep(.el-dialog) {
    width: 560px !important;
    max-width: 92%;
    border-radius: 20px;
    overflow: hidden;
    max-height: 84vh;
    display: flex;
    flex-direction: column;
    margin-top: 8vh !important;
    box-shadow:
        0 32px 64px rgba(15, 23, 42, 0.25),
        0 12px 24px rgba(47, 91, 255, 0.12);
    border: 1px solid rgba(226, 232, 240, 0.9);
  }

  :deep(.el-dialog__header) {
    padding: 0;
    margin: 0;
    border-bottom: none;
    position: relative;
    background:
        radial-gradient(ellipse 400px 200px at 10% 0%, rgba(47, 91, 255, 0.14), transparent 70%),
        radial-gradient(ellipse 400px 200px at 90% 0%, rgba(245, 158, 11, 0.1), transparent 70%),
        linear-gradient(135deg, #f7f9fc 0%, #ffffff 100%);
    border-bottom: 1px solid rgba(226, 232, 240, 0.9);

    .dialog-header {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 22px 26px;

      .dialog-header-icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background: linear-gradient(135deg, #2f5bff, #5b7cff);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 20px rgba(47, 91, 255, 0.3);
        flex-shrink: 0;
      }

      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.3;
      }

      p {
        margin: 4px 0 0;
        font-size: 12.5px;
        color: #64748b;
      }
    }
  }

  :deep(.el-dialog__body) {
    padding: 0;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  :deep(.el-dialog__footer) {
    padding: 14px 24px;
    border-top: 1px solid rgba(226, 232, 240, 0.9);
    background: #f7f9fc;
  }

  :deep(.el-dialog__headerbtn) {
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(8px);
    transition: all 0.3s ease;

    &:hover {
      background: rgba(220, 38, 38, 0.1);

      .el-dialog__close {
        color: #dc2626;
      }
    }
  }
}

.dialog-content {
  flex: 1;
  overflow-y: auto;
  line-height: 1.75;
  color: #475569;
  padding: 22px 26px;
  max-height: 56vh;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.35);
    border-radius: 3px;

    &:hover {
      background: rgba(47, 91, 255, 0.4);
    }
  }

  h2 {
    color: #0f172a;
    margin: 0 0 12px;
    padding-bottom: 12px;
    border-bottom: 2px solid transparent;
    border-image: linear-gradient(90deg, #2f5bff, #f59e0b) 1;
    font-size: 1.35em;
    font-weight: 700;
  }

  h3 {
    color: #1e293b;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 1.05em;
    font-weight: 700;
    padding-left: 10px;
    border-left: 3px solid #2f5bff;
  }

  p,
  ul {
    margin-bottom: 12px;
    font-size: 14px;
  }

  ul {
    padding-left: 20px;

    li {
      margin-bottom: 6px;
    }
  }

  strong {
    color: #1e293b;
    font-weight: 600;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;

  :deep(.el-button--primary) {
    background: linear-gradient(135deg, #2f5bff, #5b7cff);
    border: none;
    border-radius: 10px;
    padding: 9px 22px;
    font-weight: 600;
    box-shadow: 0 6px 16px rgba(47, 91, 255, 0.3);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 20px rgba(47, 91, 255, 0.4);
    }
  }
}

/* ---------- 关键帧动画 ---------- */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes glowPulse {
  0%,
  100% {
    opacity: 0.45;
  }
  50% {
    opacity: 1;
  }
}

@keyframes floatBlob {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(20px, -30px) scale(1.05);
  }
  66% {
    transform: translate(-15px, 20px) scale(0.95);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 入场动画 */
.register-form-container {
  animation: fadeInUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
  animation-delay: 0.1s;
}

/* ---------- 响应式 ---------- */
@media (max-width: 1024px) {
  .auth-split-shell {
    max-width: 420px;
  }

  .main-content {
    padding: 0 5% 0 0;
    justify-content: center;
  }

  .register-form-container .register-card {
    max-width: 100%;
    border-radius: 18px;
  }
}

@media (max-width: 768px) {
  .register-page-wrapper {
    min-height: 100vh;
    height: auto;
  }

  .main-content {
    padding: 24px 16px;
    justify-content: center;
    flex: none;
    min-height: auto;
  }

  .auth-split-shell {
    max-width: 100%;
    padding-right: 0;
  }

  .register-form-wrapper {
    padding: 20px 16px 16px;
  }

  .register-header {
    text-align: center;
    margin-bottom: 22px;

    .header-eyebrow {
      font-size: 0.72rem;
    }

    h3 {
      font-size: 1.6rem;
    }

    .header-sub {
      font-size: 0.82rem;
    }
  }

  .register-footer {
    padding: 8px 12px 6px;
    position: relative;
  }

  .register-footer .footer-content {
    padding: 12px 0;
  }

  .register-footer .footer-sections {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 8px;
    padding-bottom: 0;
    border-bottom: none;
  }

  .register-footer .footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding-top: 4px;
    border-top: 1px solid rgba(226, 232, 240, 0.6);
  }

  .register-footer .contact-info {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px 16px;
  }

  .register-footer .certification-info {
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .register-footer .beian-container {
    justify-content: center;
  }

  .register-footer .copyright-text {
    font-size: 0.75rem;
  }

  .register-footer .beian-link,
  .register-footer .icp-link {
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .auth-split-shell {
    max-width: 100%;
  }

  .register-form-wrapper {
    padding: 16px 12px 14px;
  }

  .register-header h3 {
    font-size: 1.3rem;
  }

  .wechat-register-container .wechat-qrcode img {
    width: 180px;
    height: 180px;
  }

  .wechat-register-container .expired-wrapper .expired-mask {
    top: 16px;
    left: 16px;
    right: 16px;
    bottom: 16px;
  }
}

/* 笔记本屏幕 (1024px - 1366px) */
@media (max-width: 1366px) and (min-width: 1025px) {
  .auth-split-shell {
    max-width: 400px;
  }

  .register-form-wrapper {
    padding: 34px 30px 28px;
  }
}
</style>
